import styled from 'styled-components';

import { theme } from '../../global-styles/colors';

export const CardChatStyle = styled.button`
  display: flex;
  width: 100%;
  background: white;
  border: 1px solid ${theme.divider_and_border.input_border};
  border-radius: 6px;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  text-align: left;
  cursor: pointer;

  .card-chat-left {
    display: flex;
    align-items: center;
    gap: 8px;

    &__icon {
      color: #25d366;
    }
  }

  .card-chat-messages {
    width: 24px;
    height: 24px;
    border-radius: 100%;
    background: ${theme.status.error.light};
    color: ${theme.status.error.medium};
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
